import { gql, QueryHookOptions, QueryResult } from '@apollo/client';

import { useAPIQuery } from 'Api/handler';

import { Agency, Teliway, Company } from 'Types';

export type GetFactoryResponse = {
  agencies: Agency[];
  teliways: Teliway[];
  clients: Company[];
};

export const useGetFactory = (
  options?: QueryHookOptions<GetFactoryResponse>,
): QueryResult<GetFactoryResponse> => {
  return useAPIQuery(GET_FACTORY, options);
};

export const GET_FACTORY = gql`
  query GetFactory {
    clients {
      id
      name
      type
      accounts {
        id
        codeTiers
        siretEDI
        teliwayName
        isActive
        agency {
          id
          name
          code
          teliway {
            name
            code
          }
        }
      }
      users {
        id
        firstName
        lastName
        email
        isActive
        company {
          name
        }
      }
    }
    agencies {
      id
      name
      code
      teliway {
        id
        name
        code
      }
    }
    teliways {
      id
      name
      code
    }
  }
`;
